// @flow

import './index.scss';
import * as React from 'react';
import ArticleCardReduced from '../Card/Reduced';

import type { Article } from 'stores/api/articles';

type Props = {|
    data: Article[]
|};

const ArticlesList = ({ data }: Props): React.Node => (
    <ul className="ArticlesList">
        {data.map((article: Article) => (
            <li key={article.id} className="ArticlesList__item">
                <ArticleCardReduced data={article} />
            </li>
        ))}
    </ul>
);

export default ArticlesList;
